import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { NavigationService } from "src/app/providers/navigation.service";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { MessagingService } from "src/app/providers/messaging.service";
import { Subscription } from "rxjs";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { CustomConfirmDialogComponent } from "../custom-confirm-dialog/custom-confirm-dialog.component";
import { NotificationService } from "src/app/services/notification.service";

@Component({
  selector: "sm-follower-chat",
  templateUrl: "./follower-chat.component.html",
  styleUrls: ["./follower-chat.component.scss"],
})
export class FollowerChatComponent implements OnInit, OnDestroy {
  loader: boolean = false;
  searchKey: any = "";
  myProfileHash: any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH);
  chatThreads: any = [];
  private _apiSubscription: Subscription;
  constructor(
    private messagingService: MessagingService,
    private _modelRef: MatDialog,
    private angularFireMessaging: AngularFireMessaging,
    private _navService: NavigationService,
    private _apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public parentData: any
  ) {
    this._navService.hideSidebarAndNav = false;
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.listenForMessageThreadUpdates();
    }
    this._apiSubscription = this._apiservice.apiResult.subscribe(
      (resData: any) => {
        if (
          resData.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID
        ) {
          this.chatThreads = [];
          if (resData.result) {
            resData.result.forEach((element: any) => {
              if (element.senderInfo && element.receiverInfo) {
                if (
                  element.senderInfo &&
                  typeof element.senderInfo == "string"
                ) {
                  element.senderInfo = JSON.parse(element.senderInfo);
                }
                if (
                  element.receiverInfo &&
                  typeof element.receiverInfo == "string"
                ) {
                  element.receiverInfo = JSON.parse(element.receiverInfo);
                }
                let changedTime = this.formatTimeAgo(element.lastMessageTime);
                element.lastMTime = changedTime;
                element.isSelected = 0;

                this.chatThreads.push(element);
              }
            });
            if (this.sThread && this.sThread != "") {
              const index = this.chatThreads.findIndex(
                (item: any) => item.hash_id == this.sThread.hash_id
              );
              this.chatThreads[index].isSelected = 1;
            }

            this.sortMessagesByTime(this.chatThreads);
            console.log(this.chatThreads);
          }
          this.loaderservice.showLoader = false;
          this.loader = false;
        }
        if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_GET_SUB_MESSAGES_BY_ID
        ) {
          this.selectedThread = [];
          if (resData.result) {
            resData.result.forEach((element: any) => {
              if (element.senderInfo && typeof element.senderInfo == "string") {
                element.senderInfo = JSON.parse(element.senderInfo);
              }
              if (
                element.receiverInfo &&
                typeof element.receiverInfo == "string"
              ) {
                element.receiverInfo = JSON.parse(element.receiverInfo);
              }
              if (element.senderInfo.hash_id == this.myProfileHash) {
                element.isSender = 1;
                element.iSent = 1;
              }
              if (element.receiverInfo.hash_id == this.myProfileHash) {
                element.isSender = 0;
                element.iSent = 0;
              }
              // let changedTime = this.formatTimeAgo(element.lastMessageTime)
              // element.lastMTime = changedTime

              this.selectedThread.push(element);
            });
            // this.sortMessagesByTime(this.chatThreads)
            console.log(this.selectedThread);
            this.message = "";
            this.textAreaDisabled = false;
          }
          setTimeout(() => {
            this.scrollToBottom();
          }, 1);
          this.chatLoader = false;
        }
        if (
          resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_MESSAGE_THREAD
        ) {
          if (resData.result) {
            resData.result =
              typeof resData.result == "string"
                ? JSON.parse(resData.result)
                : resData.result;
            this.parentData.previousChatHash = resData.result.hash_id;
            this._apiservice.getSubMessagesByID(
              this.parentData.previousChatHash
            );
            // this._apiservice.getMessagesByID()
          }
        }
        if (resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_MESSAGE) {
          if (resData.result) {
            // resData.result = typeof resData.result == 'string' ? JSON.parse(resData.result): resData.result
            // this.parentData.previousChatHash = resData.result.hash_id
            this._apiservice.getSubMessagesByID(
              this.parentData.previousChatHash
            );
            // this._apiservice.getMessagesByID()

            this.message = "";
            this.textAreaDisabled = false;
          }
        }
      }
    );
  }

  selectedThread: any = [];
  chatLoader: boolean = false;
  senderHashId: any;
  receiverHashId: any;
  sThread: any = "";
  selectThread(thread: any): void {
    this.message = "";
    this.sThread = thread;
    this.chatThreads.forEach((element: any) => {
      element.isSelected = 0;
    });
    thread.isSelected = 1;
    this.chatLoader = true;
    this._apiservice.getSubMessagesByID(thread.hash_id);
    this.senderHashId =
      thread.isSender == 0
        ? thread.receiverInfo.hash_id
        : thread.senderInfo.hash_id;
    this.receiverHashId =
      thread.isSender == 0
        ? thread.senderInfo.hash_id
        : thread.receiverInfo.hash_id;
  }

  ngOnInit(): void {
    if (
      this.parentData.previousChatHash &&
      this.parentData.previousChatHash != null &&
      this.parentData.previousChatHash != "null"
    ) {
      this.chatLoader = true;
      this._apiservice.getSubMessagesByID(this.parentData.previousChatHash);
    } else {
    }
    // this.loader = true
    // this.loaderservice.showLoader = true
    // this._apiservice.getMessagesByID()
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    if (this.messagesubscription) {
      this.messagesubscription.unsubscribe();
    }
  }
  @ViewChild("scrollableDiv") scrollableDiv!: ElementRef;
  scrollToBottom() {
    if (this.scrollableDiv) {
      this.scrollableDiv.nativeElement.scrollTop =
        this.scrollableDiv.nativeElement.scrollHeight;
    }
  }

  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }
  message: any = "";
  textAreaDisabled: boolean = false;
  sendMessage() {
    if (this.message && this.message != "") {
      this.textAreaDisabled = true;
      let data = {
        messageInfo: {
          hash_id: this.parentData.previousChatHash,
          message: this.message,
        },
      };
      Object.keys(data.messageInfo).forEach((key) => {
        if (
          (data.messageInfo as any)[key] === null ||
          (data.messageInfo as any)[key] == ""
        ) {
          delete (data.messageInfo as any)[key];
        }
      });
      console.log(data);
      console.log(this.myProfileHash);
      console.log(this.parentData.folowerProfileHash);

      this._apiservice.updateMessageThread(
        this.myProfileHash,
        this.parentData.folowerProfileHash,
        localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
        ),
        data
      );
    }
  }

  showMenu = false;

  showCustomMenu(event: MouseEvent) {
    event.preventDefault();
    this.showMenu = true;
  }

  handleMenuItemClick(option: string) {
    console.log("Menu item clicked:", option);
    this.showMenu = false;
  }

  deleteMessage(messageHash: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this message?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          messageInfo: {
            isDelete: 1,
          },
        };

        this.chatLoader = true;
        this._apiservice.updateMessage(data, messageHash);
      }
    });
  }

  sortMessagesByTime(messages: any) {
    return messages.sort((a: any, b: any) => {
      const timeA = new Date(a.lastMessageTime).getTime();
      const timeB = new Date(b.lastMessageTime).getTime();
      return timeB - timeA;
    });
  }
  formatTimeAgo(lastMessageTime: string): string {
    const currentTime: Date = new Date();
    const messageTime: Date = new Date(lastMessageTime);
    const timeDifference: number =
      currentTime.getTime() - messageTime.getTime();
    const seconds: number = Math.floor(timeDifference / 1000);
    const minutes: number = Math.floor(seconds / 60);
    const hours: number = Math.floor(minutes / 60);
    const days: number = Math.floor(hours / 24);

    if (seconds < 60) {
      return `${seconds}s ago`;
    } else if (minutes === 1) {
      return `1m ago`;
    } else if (minutes < 60) {
      return `${minutes}m ago`;
    } else if (hours === 1) {
      return `1h ago`;
    } else if (hours < 24) {
      return `${hours}h ago`;
    } else if (days === 1) {
      return `yesterday`;
    } else if (days <= 7) {
      return `${days}d ago`;
    } else {
      // If the date is beyond a week, return the original date
      return messageTime.toISOString().split("T")[0];
    }
  }

  refresh() {
    this.chatLoader = true;
    this._apiservice.getSubMessagesByID(this.parentData.previousChatHash);
  }

  private messagesubscription: Subscription = new Subscription();
  listenForMessageThreadUpdates() {
    this.messagesubscription = this.notificationService
      .getNotificationByType("updateMessageThread")
      .subscribe((payload) => {
        if (true) {
          console.log("Message thread update:", payload);

          if (
            (payload.data.misc.senderHash == this.senderHashId &&
              payload.data.misc.receiverHash == this.receiverHashId) ||
            (payload.data.misc.senderHash == this.receiverHashId &&
              payload.data.misc.receiverHash == this.senderHashId)
          ) {
            this._apiservice.getSubMessagesByID(this.parentData.previousChatHash);
          } else {
            // this._apiservice.getMessagesByID();
          }
        }
      });
  }
}
